import React, { useRef, useContext, useState, FocusEvent, useEffect } from "react";
import {
  callApi,
  serializeObject,
  emailCheck,
  setLocalStorage,
} from "bodycodi/cmap/app/js/common.js";
import { useHistory } from "react-router-dom";

import { DispatchContext } from "bodycodi/cmap/app/components/common/context";
import Join from "bodycodi/cmap/app/components/cmap1010/join";
import { InputLogin } from "bodycodi/cmap/app/components/cmap1010/input";
import FindPassword from "./findPassword";
import FindEmailPop from "./findEmailPop";
import logo from "bodycodi/cmap/app/img/bodycodi-logo.png";
import { api } from "bodycodi/cmap/app/js/api";
import useDeviceInfo from "bodycodi/cmap/app/hooks/useDeviceInfo";
import FirstInInfo from "bodycodi/cmap/app/components/cmap1010/FirstInInfo";

const Login = () => {
  const formRef: any = useRef();
  const exitAppRef = useRef(false);
  const history = useHistory();
  const { dispatch } = useContext(DispatchContext);
  const [errorText, setErrorText] = useState<Array<string>>(["", ""]);
  const isDoubleClickBackRef = useRef<boolean>(false);
  const { appToken, deviceOsCode, deviceName, deviceMacId } = useDeviceInfo();
  const onBoarding = window.localStorage.getItem("onBoarding");

  useEffect(() => {
    window.addEventListener("backPress", (event: any) => {
      if (window.popHis.length === 0) {
        if (isDoubleClickBackRef.current) {
          window.newCoach?.exitApp();
          return;
        }
        if (event.detail.data === 2) {
          dispatch({
            type: "UPDATE",
            data: {
              toast: true,
              toastText: `<span>버튼을 한번 더 누르면 종료됩니다.</span>`,
            },
          });
          isDoubleClickBackRef.current = true;
          setTimeout(() => {
            isDoubleClickBackRef.current = false;
          }, 2000);
        }
      } else {
        for (let i = 0; i < event.detail.data; i++) {
          const { id, name } = window.popHis[window.popHis.length - 1];
          dispatch({ type: "POP_UP_OPEN", id: id, open: { [name]: false } });
        }
      }
    });
    return window.removeEventListener("backPress", (event: any) => {
      if (window.popHis.length === 0) {
        if (isDoubleClickBackRef.current) {
          window.newCoach?.exitApp();
          return;
        }
        if (event.detail.data === 2) {
          dispatch({
            type: "UPDATE",
            data: {
              toast: true,
              toastText: `<span>버튼을 한번 더 누르면 종료됩니다.</span>`,
            },
          });
          isDoubleClickBackRef.current = true;
          setTimeout(() => {
            isDoubleClickBackRef.current = false;
          }, 2000);
        }
      } else {
        for (let i = 0; i < event.detail.data; i++) {
          const { id, name } = window.popHis[window.popHis.length - 1];
          dispatch({ type: "POP_UP_OPEN", id: id, open: { [name]: false } });
        }
      }
    });
  }, []);

  useEffect(() => {
    // AOS
    document.addEventListener("message", ({ data }: any) => {
      // 안드로이드 뒤로가기 처리
      if (typeof data === "string" && data.includes("backAction")) {
        const objData = JSON.parse(data);
        if (objData?.name === "backAction") {
          if (window.popHis.length === 0) {
            if (exitAppRef.current) {
              window.ReactNativeWebView.postMessage("exitApp");
            }
            exitAppRef.current = true;
            setTimeout(() => {
              exitAppRef.current = false;
            }, 2000);
            dispatch({
              type: "UPDATE",
              data: {
                toast: true,
                toastText: `<span>뒤로가기 버튼을 한번 더 누르면 종료됩니다.</span>`,
              },
            });
          } else {
            const { id, name } = window.popHis[window.popHis.length - 1];
            dispatch({ type: "POP_UP_OPEN", id: id, open: { [name]: false } });
          }
        }
      }
    });
  }, []);

  useEffect(() => {
    const tokenData = window.localStorage.getItem("accessToken");
    if (tokenData) {
      api.defaults.headers.common["Authorization"] = `Bearer ${tokenData}`;
      history.replace("/home");
    }
  }, []);

  const openAlert = (body: string, header: string) => {
    dispatch({
      type: "ALERT_SETTING",
      data: {
        alert: true,
        cancleYn: false,
        redYn: false,
        header: header,
        body: body,
        closeAlert: () => {
          return;
        },
        cancelAlert: () => {
          return;
        },
      },
    });
  };

  const clickLogin = () => {
    const data: any = serializeObject({ element: formRef.current });
    if (emailCheck(data.email)) {
      const input = formRef.current.querySelector("input[type='text']");
      input.focus();
      return;
    }
    data["appToken"] = appToken;
    data["deviceOsCode"] = deviceOsCode;
    data["deviceName"] = deviceName;
    data["deviceMacId"] = deviceMacId;

    callApi("/cmap1010/execLogin", data, "POST").then(
      ({ MsgVO, accessToken, seqMobileMembers, seqManagerMobileDevice }) => {
        if (MsgVO.msgCd === "CMAP1010-00") {
          api.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
          setLocalStorage("accessToken", accessToken);
          setLocalStorage("seqMobileMembers", seqMobileMembers);
          setLocalStorage("seqManagerMobileDevice", seqManagerMobileDevice);
          history.replace("/home");
        } else {
          openAlert(MsgVO.msgCtnt, "로그인");
        }
      }
    );
  };

  const openTernServicePop = () => {
    dispatch({ type: "POP_UP_OPEN", id: "TERN_SERVICE_POP", open: { ternServicePop: true } });
  };

  const blurEmail = (e: FocusEvent<HTMLInputElement, Element>) => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage("getDeviceInfo");
    }
    const input = e.currentTarget as HTMLInputElement;
    if (!emailCheck(input.value)) {
      errorText[0] = "";
    } else {
      errorText[0] = "유효한 형식의 이메일 아이디가 아닙니다.";
    }
    setErrorText([...errorText]);
  };

  const clickFindPassword = () => {
    dispatch({ type: "POP_UP_OPEN", id: "FIND_PASSWORD_POP", open: { findPasswordPop: true } });
  };

  const clickFindEmail = () => {
    dispatch({ type: "POP_UP_OPEN", id: "FIND_EMAIL_POP", open: { findEmailPop: true } });
  };

  return (
    <>
      <div className="login-wrap">
        <div>
          <div className="bodycodi-logo">
            <img src={logo} />
          </div>
          <div className="input-wrap" ref={formRef}>
            <InputLogin
              type="text"
              name="email"
              placeholder="이메일 입력"
              title="이메일 아이디"
              onBlur={blurEmail}
              errorText={errorText[0]}
            />
            <InputLogin
              type="password"
              name="password"
              placeholder="비밀번호 입력"
              title="비밀번호"
              onBlur={() => ({})}
              errorText={errorText[1]}
            />
          </div>
          <div className="btn-wrap">
            <div className="btn blue" onClick={clickLogin}>
              로그인
            </div>
            <div className="btn white" onClick={openTernServicePop}>
              회원가입
            </div>
          </div>
        </div>
        <div className="login-footer">
          <div className="btn" onClick={clickFindEmail}>
            아이디 찾기
          </div>
          <div className="slash">|</div>
          <div className="btn" onClick={clickFindPassword}>
            비밀번호 찾기
          </div>
        </div>
      </div>

      <Join />
      <FindPassword />
      <FindEmailPop />
      {onBoarding !== "Y" && <FirstInInfo />}
    </>
  );
};

export default Login;
